import Chart from 'chart.js/auto';


const debris = [1,4,15,292,308,424,501,1169,1343,1403,1680,1923,2481,2638,2892,3119,3352,3913,4335,4547,4683,4803,4778,5158,7013,7241,7276,7431,8027,8421,8292,8176,8189,8437,8743,10605,11550,11795,11694,12114,12032,15772,16021,16157,15983,15827,15781,15709,16503,16502,16058,16002,15907,15943,15808,15539,15154,14868,14776,14724,14825,14868,14742,14554,13538];
const payload = [1,4,10,16,26,40,68,128,153,185,211,240,280,350,405,461,512,583,663,715,767,785,805,865,907,958,1018,1079,1147,1208,1238,1252,1303,1337,1362,1397,1439,1458,1482,1560,1993,2049,2078,2080,2100,2125,2146,2161,2193,2234,2274,2330,2361,2397,2432,2552,2600,2621,2676,2949,3144,3427,4500,6018,7870];
const rocketBodis = [1,3,9,13,23,34,51,81,103,129,151,172,201,243,277,308,348,406,470,514,544,555,566,605,626,683,738,803,840,875,907,934,978,1003,1046,1090,1131,1158,1186,1225,1235,1240,1234,1210,1200,1211,1216,1218,1234,1257,1276,1287,1311,1321,1333,1338,1342,1361,1382,1405,1447,1464,1471,1498,1528];


// Daten für das Flächendiagramm
const data = {
  labels: [1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975, 1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000, 2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022],
  datasets: [
    {
      label: 'Rocket bodies',
      data: rocketBodis,
      backgroundColor: 'RGB(3, 40, 89)', // Hintergrundfarbe der Fläche
      borderColor: '#ffff', // Randfarbe der Fläche
      borderWidth: 1, // Randbreite der Fläche
      fill: true,
      pointHoverRadius: 4,
      pointHoverBackgroundColor: 'white'
    },
    {
      label: 'Payload',
      data: payload,
      backgroundColor: 'RGB(1, 28, 64)', // Hintergrundfarbe der Fläche
      borderColor: '#ffff', // Randfarbe der Fläche
      borderWidth: 1, // Randbreite der Fläche
      fill: true,
      pointHoverRadius: 4,
      pointHoverBackgroundColor: 'white'
    },
    {
      label: 'Debris',
      data: debris,
      backgroundColor: 'RGB(1, 17, 38)', // Hintergrundfarbe der Fläche
      borderColor: '#ffff', // Randfarbe der Fläche
      borderWidth: 1, // Randbreite der Fläche
      fill: true,
      pointHoverRadius: 4,
      pointHoverBackgroundColor: 'white'
    },
  ]
};

const getOrCreateTooltip = (chart) => {
  let tooltipEl = chart.canvas.parentNode.querySelector('div');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.classList.add('tooltip-div');

    const table = document.createElement('table');
    table.style.margin = '0px';

    const line = document.createElement('div');
    line.classList.add('tooltip-line');
    line.style.height = chart.height  + 'px';

    tooltipEl.appendChild(line);
    tooltipEl.appendChild(table);
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  return tooltipEl;
};

const externalTooltipHandler = (context) => {
  // Tooltip Element
  const {chart, tooltip} = context;
  const tooltipEl = getOrCreateTooltip(chart);

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines);

    const tableHead = document.createElement('thead');

    titleLines.forEach(title => {
      const tr = document.createElement('tr');
      tr.style.borderWidth = 0;

      const th = document.createElement('th');
      th.style.borderWidth = 0;
      const text = document.createTextNode(title);

      th.appendChild(text);
      tr.appendChild(th);
      tableHead.appendChild(tr);
    });

    const tableBody = document.createElement('tbody');
    bodyLines.forEach((body, i) => {

      const tr = document.createElement('tr');
      tr.style.backgroundColor = 'inherit';
      tr.style.borderWidth = 0;

      const td = document.createElement('td');
      td.style.borderWidth = 0;

      const text = document.createTextNode(body);

      td.appendChild(text);
      tr.appendChild(td);
      tableBody.appendChild(tr);
    });

    const tableRoot = tooltipEl.querySelector('table');

    // Remove old children
    while (tableRoot.firstChild) {
      tableRoot.firstChild.remove();
    }

    // Add new children
    tableRoot.appendChild(tableHead);
    tableRoot.appendChild(tableBody);
  }

  const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;

  // Display, position, and set styles for font
  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY - 40 + 'px';
};

// Optionen für das Flächendiagramm
const options = {
  scales: {
    y: {
      beginAtZero: true ,// Die y-Achse startet bei 0
      stacked: true,
    }
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  tooltip: {
    usePointStyle: true,
  },
  plugins: {
    tooltip: {
      enabled: false,
      external: externalTooltipHandler,
      itemSort: function(a, b) {
        return b.datasetIndex - a.datasetIndex
      },
    },
    legend: {
      display: false
   },
  },
};

let observerOptions = {
  root: document.querySelector("#scrollArea"),
  rootMargin: "0px",
  threshold: 1.0,
};

const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const areaChart = new Chart(document.getElementById('areaChart'), {
        type: 'line',
        data: data,
        options: options
      });
    }
  })
}, observerOptions)

observer.observe(document.querySelector('#areaChart'));

// Flächendiagramm erstellen
